module.exports = __webpack_public_path__ + "static/media/amenities_3.e0170f0d.svg";